import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppConstants } from "@core/constants";
import { CustomRendererService } from "@shared/services/custom-renderer.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { OnboardingService } from "@shared/services/onboarding/onboarding.service";

@Injectable()
export class UseCasesResolver {
  private snackBar: MatSnackBar = inject(MatSnackBar);
  private onboardingService: OnboardingService = inject(OnboardingService);
  private customRendererService: CustomRendererService = inject(CustomRendererService);

  public resolve(): Observable<any> {
    // const useCaseList: any[] = [
    //   {
    //     "id": 83,
    //     "title": "Example Cycling Use Case (Lactate Test)",
    //     "description": "[Case 2] Example Cycling Use Case (Lactate Test) Description",
    //     "image": "https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/cycling/Cycling.png"
    //   },
    // ];
    // useCaseList.forEach((item: any) => {
    //   item['tags'] = [];
    //   item['buttonName'] = 'Use This Case';
    //   item['is_onboarding_track'] = true;
    // });
    //
    // return of(useCaseList);


    return this.onboardingService.getUseCases()
      .pipe(
        catchError(error => {
            this.customRendererService.hide(AppConstants.MAT_SPINNER_CLASS);
            this.snackBar.open(error, 'OK', AppConstants.TOAST_CONFIG.ERROR);
            return of(null);
          }
        )
      );
  }
}
